import React from 'react';
import { Grid, Modal } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  ModalCancelButton,
  ModalDeleteButton
} from './parts/cloudStorage/style/style';

type Tprops = {
  documentType: string;
  documentDeleteModal: boolean;
  setDocumentDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  deleteDocument: any;
};

export const DocumentDeleteModal: React.FC<Tprops> = (props: Tprops) => {
  const {
    documentType,
    documentDeleteModal,
    setDocumentDeleteModal,
    deleteDocument
  } = props;

  const classes = useStyles();

  return (
    <Modal
      open={documentDeleteModal}
      onClose={() => setDocumentDeleteModal(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12} className={classes.container}>
          <div style={{ textAlign: 'center', margin: '50px 0px' }}>
            <p style={{ fontSize: 18, marginTop: 18 }}>
              この{documentType}を<span style={{ color: 'red' }}>削除</span>
              します。
              <br />
              ※この操作は取り消せません。
            </p>
          </div>
        </Grid>
        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setDocumentDeleteModal(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalDeleteButton
            variant='contained'
            onClick={() => {
              deleteDocument();
              setDocumentDeleteModal(false);
            }}
          >
            削除
          </ModalDeleteButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    paper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '70%',
      overflow: 'hidden'
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '40%'
    },
    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    }
  })
);
